import { render, staticRenderFns } from "./person-transferNew.vue?vue&type=template&id=2d0ba27c&scoped=true&"
import script from "./person-transferNew.vue?vue&type=script&lang=js&"
export * from "./person-transferNew.vue?vue&type=script&lang=js&"
import style0 from "./person-transferNew.vue?vue&type=style&index=0&id=2d0ba27c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0ba27c",
  null
  
)

export default component.exports